import { render, staticRenderFns } from "./customerPhoneInput.vue?vue&type=template&id=4eb38f70"
import script from "./customerPhoneInput.vue?vue&type=script&setup=true&lang=js"
export * from "./customerPhoneInput.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports